import _ from 'lodash';
import React, { FunctionComponent } from 'react';
import './index.scss';
import {
  ForgeAvatar,
  ForgeDivider,
  ForgeIcon,
  ForgeIconButton,
  ForgeList,
  ForgeListItem,
  ForgeExpansionPanel,
  ForgeOpenIcon,
} from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import optionallyLocalizeUrls from '../../utils/optionally_localize_urls';
import { canSeeCreateAssetsDialog } from '../../utils/site_chrome_rights';

interface MobileActionPageProps {
  closeCallback: () => void;
  openMobileCreateDrawer: () => void;
}

interface Locale {
  url: string;
  text: string;
}

const MobileActionPage: FunctionComponent<MobileActionPageProps> = ({
  closeCallback,
  openMobileCreateDrawer
}) => {
  const availableLocales = _.get(window, 'socrata.availableLocales', []);
  const currentUser = _.get(window, 'socrata.currentUser', {});
  const currentLocale = _.get(window, 'socrata.locale');
  const scope = 'shared.site_chrome.forge_omnibar';
  const { email, profile_image, displayName } = currentUser;
  const createAssetsDrawer = () => {
    openMobileCreateDrawer();
    closeCallback();
  };

  const localeList = availableLocales.map((locale: Locale, i: number) => {
    return (
      (<ForgeListItem indented onClick={() => location.href = locale.url} key={i}>
        <ForgeIcon name="translate" slot="start" />
        {locale.text}
      </ForgeListItem>)
    );
  });

  return (<div className='more-action-page'>
    <div className='more-action-page-header'>
      <ForgeIconButton
        id='close-more-action-page'
        aria-label="View user profile"
        className="tyler-icons"
        onClick={closeCallback}>
        <ForgeIcon name="close" />
      </ForgeIconButton>
    </div>
    <ForgeList>
      <div className='more-action-page-profile'>
        <ForgeAvatar image-url={profile_image ? profile_image : null} text={displayName}></ForgeAvatar>
        <span className='forge-typography--subheading2'>{displayName}</span>
        <span className='forge-typography--heading1'>{email}</span>
      </div>
      <ForgeDivider />
      {canSeeCreateAssetsDialog() ? (
        <>
          <ForgeListItem onClick={createAssetsDrawer}>
            <ForgeIcon name="add_circle_outline" slot="start"></ForgeIcon>
            <button type="button">
              <span>{I18n.t(`${scope}.create_assets.title`)}</span>
            </button>
            <ForgeIcon name="keyboard_arrow_right" slot="end"></ForgeIcon>
          </ForgeListItem>
          <ForgeDivider />
        </>
      ) : null}
      {availableLocales.length > 0 ? (
        <ForgeExpansionPanel>
          <ForgeListItem slot="header">
            <ForgeIcon name="translate" slot="start" />
            {I18n.t(`${scope}.language`)} {`(${currentLocale.toUpperCase()})`}
            <ForgeOpenIcon slot="end" />
          </ForgeListItem>
          <ForgeList>
            {localeList}
          </ForgeList>
        </ForgeExpansionPanel>
      ) : null}
      <ForgeExpansionPanel open>
        <ForgeListItem slot="header" id="site-chrome-internal-menu-title">
          <ForgeIcon name="help" slot="start" />
          {I18n.t(`${scope}.help_menu.title`)}
          <ForgeOpenIcon slot="end" />
        </ForgeListItem>
        <ForgeList>
          <ForgeListItem indented onClick={() => location.href = 'https://support.socrata.com/hc/en-us/requests/new'}>
            <ForgeIcon name="help_outline" slot="start" />
            {I18n.t(`${scope}.help_menu.help_link`)}
          </ForgeListItem>
          <ForgeListItem indented onClick={() => location.href = 'https://support.socrata.com/hc/en-us'}>
            <ForgeIcon name="menu_book" slot="start" />
            {I18n.t(`${scope}.help_menu.knowledge`)}
          </ForgeListItem>
          <ForgeListItem indented onClick={() => location.href = 'http://learn.socrata.com'}>
            <ForgeIcon name="school" slot="start" />
            {I18n.t(`${scope}.help_menu.education`)}
          </ForgeListItem>
          <ForgeListItem indented onClick={() => location.href = '/videos'}>
            <ForgeIcon name="video_library" slot="start" />
            {I18n.t(`${scope}.help_menu.quick_start_videos`)}
          </ForgeListItem>
          <ForgeListItem indented onClick={() => location.href = 'https://support.socrata.com/hc/en-us/categories/202630927'}>
            <ForgeIcon name="campaign" slot="start" />
            {I18n.t(`${scope}.help_menu.release_notes`)}
          </ForgeListItem>
          <ForgeListItem indented>
            <ForgeIcon name="code" slot="start" onClick={() => location.href = 'https://dev.socrata.com'} />
            {I18n.t(`${scope}.help_menu.developer_resources`)}
          </ForgeListItem>
        </ForgeList>
      </ForgeExpansionPanel>
      <ForgeDivider />
      <ForgeListItem onClick={() => location.href = optionallyLocalizeUrls('/logout')}>
        <ForgeIcon name="logout" slot="start" />
        {I18n.t(`${scope}.navigation.sign_out`)}
      </ForgeListItem>
    </ForgeList>
  </div>);
};

export default MobileActionPage;
